














































import Vue from "vue";

export default Vue.extend({
    data() {
        return {
            columns: [
                {
                    title: "Anzahl Gäste",
                    dataIndex: "anzahlGäste",
                    key: "anzahlGäste",
                },
                {
                    title: "Umsatz",
                    dataIndex: "umsatz",
                    key: "umsatz",
                },
                {
                    title: "Anzahl Mitarbeiter (max. Soll)",
                    dataIndex: "maxAnzahlMitarbeiter",
                    key: "maxAnzahlMitarbeiter",
                    scopedSlots: { customRender: "maxAnzahlMitarbeiter" }
                },
            ],
            rows: [] as any[],
        };
    },
  created() {

      // set columns of table
        const groupColumns = this.$store.state.groups?.map((group:string)=>({
            title: group,
            dataIndex: group,
            key: group,
            scopedSlots: { customRender: group }
        }));
        this.columns.push(...groupColumns);

        // calculate and create rows
        const benötigteProduktivität = this.$store.state.personalkostensatz /  (this.$store.state.personalkostenquote / 100);
        const stundenumsatzProGast = this.$store.state.umsatzProGast / this.$store.state.gastVerweildauer;
        const gästeproduktivität = benötigteProduktivität / stundenumsatzProGast;
        const maxHourlySales = this.$store.getters.getMaxSales()* 1.25;
        const numberOfRows = maxHourlySales / stundenumsatzProGast / gästeproduktivität;
        for (let i = 0; i <= numberOfRows; i++) {
            const anzahlGäste = (i+1) * gästeproduktivität;
            const fromAnzahlGäste = (i===0) ? 0 : anzahlGäste - gästeproduktivität/2;
            const toAnzahlGäste = anzahlGäste + gästeproduktivität/2;
            let sum = 0;
            for (const group of this.$store.state.groups ?? []) {
                const n = this.$store.getters.getMeoValueForGroupAndRowId(group, i);
                sum += parseInt((n !== "" ? n : 0));
            }
            this.rows.push({
                anzahlGäste: Math.round(fromAnzahlGäste + 1) + " bis " + Math.round(toAnzahlGäste),
                umsatz: Math.round(fromAnzahlGäste * stundenumsatzProGast + 1) + " bis " + Math.round(toAnzahlGäste * stundenumsatzProGast) + " €",
                key: i.toString(),
                maxAnzahlMitarbeiter: i + 1,
                isOverstaffed: sum > i + 1,
            });
        }

  },
    methods: {
        validateRow:function(record:any,group:string) {
            const text = this.$store.getters.getMeoValueForGroupAndRowId(group, record.key);
            return record.isOverstaffed && text && text.toString().trim() !== "" ? "overstaffed" : null;
        },
        onCellChange(rowId: string, group: string, event: any) {

            let value = parseFloat(event.currentTarget.value);
            if (!value || isNaN(value)) {
                value = 0;
            }

            // keep value in vuex store
            const data = [...this.rows];
            const target = data.find(item => item.key === rowId);
            if (target) {
                this.$store.commit("updateMeoValueForGroupAndRowId",{
                    group,
                    rowId,
                    value,
                });
            }

            // determine if overstaffed
            let sum = 0;
            for (const group of this.$store.state.groups ?? []) {
                sum += this.$store.getters.getMeoValueForGroupAndRowId(group, rowId);
            }
            this.$data.rows[rowId].isOverstaffed = false; // reset flag first in order to refresh all affected controls
            this.$data.rows[rowId].isOverstaffed = sum > this.$data.rows[rowId].maxAnzahlMitarbeiter;

        }
    }
});
